import React from "react";
import { PIDModalTableRow } from "./PIDComponents";
import { pipeSpecs } from "./PIDModalData";

const PipeSpecTable = () => {
  return (
    <>
      <div>
        <table
          className="table table-striped table-hover table-responsive"
          style={{ margin: "0" }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "center",
                }}
              >
                Material Code
              </th>
              <th
                style={{
                  textAlign: "center",
                }}
              >
                Material Description
              </th>
            </tr>
          </thead>
          <tbody>
            {pipeSpecs.map((prop, i) => (
              <PIDModalTableRow
                key={i}
                column1={prop.materialCode}
                column2={prop.materialDescription}
              />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PipeSpecTable;
